enum Permission {
  NavCredentials = 'nav:credentials',
  NavRecommendation = 'nav:recommendation',
  PipelineRefresh = 'pipeline:refresh',
  OpenAiMonitor = 'openai:monitor',
  DevOpenAiPrompt = 'dev:openai:prompt',
  ManualUpload = 'internal:manualUpload',
  ManageUsers = 'manage:users',
  ManageSuppliers = 'manage:suppliers',
  ViewSuppliers = 'view:suppliers',
  ManageIntegrations = 'manage:integrations',
  AccessAgent = 'access:agent',
}

/* eslint import/prefer-default-export: "off" */
export { Permission };
